module.exports = __webpack_public_path__ + "static/media/thetatau.469f7020.png";